import React from 'react';
import { Link } from 'react-router-dom';
import { Lightbulb, Wallet, ShieldCheck, BarChart3, Users, Film, Globe } from 'lucide-react';
import MbogiSolution from './MbogiSolution';
import MbogiShowcase from './MbogiShowcase';
import MbogiCapitalPage from './HowItWorks';

export default function Home() {
  return (
    <div className="bg-[#fdfcf9] font-sans text-[#0a1d2e]">

      {/* HERO SECTION */}
      <section className="relative min-h-[90vh] flex items-center pt-10 pb-20 px-6 md:px-12">
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="z-10">
            <span className="inline-block bg-[#f3e8d6] text-[#c07d3e] text-xs font-bold px-3 py-1 rounded-full mb-6">
              ✦ Opening Doors to African Cinema
            </span>
            <h1 className="text-5xl md:text-7xl font-bold leading-tight tracking-tight">
              Fund Stories. <br />
              <span className="text-[#c07d3e]">Own the Future.</span>
            </h1>
            <p className="mt-6 text-lg text-gray-600 max-w-lg leading-relaxed">
              Crowd-Investing African Film. <br />
              Transparent. Fair. Community-Owned.
            </p>

            
            <p className="mt-4 text-xs text-gray-400">Join 5,000+ pioneers waiting to fund African cinema.</p>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl transform lg:rotate-2 hover:rotate-0 transition-transform duration-500">
              <img 
                src="/images/filmset.jpg" 
                alt="Film Set" 
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
              <div className="absolute bottom-6 left-6 text-white bg-black/40 backdrop-blur-md p-4 rounded-xl border border-white/20">
                <p className="text-xs uppercase tracking-widest font-semibold opacity-80">Currently Filming</p>
                <p className="font-bold text-lg">"Nairobi Nights"</p>
                <p className="text-xs text-orange-300 mt-1">Target Fund: $250K • 78% Funded</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS SECTION */}
    
      <MbogiShowcase />
      <MbogiCapitalPage />
      {/* <MbogiSolution /> */}

      {/* WHO THIS IS FOR */}
      <section className="py-24">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-2">Who This Is For</h2>
          <div className="w-16 h-1 bg-[#c07d3e] mx-auto rounded-full mb-16"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { 
                title: 'Filmmakers', 
                desc: 'Access non-predatory capital, maintain creative control, and build a dedicated fanbase.',
                img: 'https://images.unsplash.com/photo-1533488765986-dfa2a9939acd?auto=format&fit=crop&q=80&w=600',
                icon: <Film />
              },
              { 
                title: 'Investors', 
                desc: 'Diversify your portfolio with cinematic assets. Own a piece of the burgeoning African film industry.',
                img: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=600',
                icon: <Users />
              },
              { 
                title: 'The Diaspora', 
                desc: 'Directly support and profit from authentic portrayals of African stories on the global stage.',
                img: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&q=80&w=600',
                icon: <Globe />
              }
            ].map((item, i) => (
              <div key={i} className="group relative overflow-hidden rounded-3xl aspect-[4/5] shadow-lg">
                <img src={item.img} alt={item.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1d2e] via-[#0a1d2e]/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-8 text-left text-white">
                  <h4 className="text-2xl font-bold mb-3">{item.title}</h4>
                  <p className="text-sm text-gray-300 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="bg-[#0a1d2e] py-24 px-6">
        <div className="container mx-auto max-w-4xl text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to script the next success story?</h2>
          <p className="text-gray-400 mb-10 text-lg">
            Be the first to know when we launch and get exclusive early-bird investment opportunities.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center">
            <input 
              type="email" 
              placeholder="Enter your email address" 
              className="px-8 py-4 rounded-full bg-white/10 border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#c07d3e] sm:w-96 text-white"
            />
            <button className="bg-[#c07d3e] hover:bg-[#a66a33] px-10 py-4 rounded-full font-bold transition-all">
              Secure Early Access
            </button>
          </div>
          <p className="mt-6 text-sm text-gray-500">Join 5,000+ pioneers waiting to fund African cinema.</p>
        </div>
      </section>

    </div>
  );
}